import { Injectable, NgZone } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { IPraticaEvent } from '../../opening/i-pratica-event';
import { SseService } from './sse.service';
import { LoaderService } from './loader.service';

@Injectable({
  providedIn: 'root',
})
export class EventService {
  constructor(
    private zone: NgZone,
    private sseService: SseService,
    private loader: LoaderService
  ) {}

  getServerSentEvent(subscriberId: string) {
    const url = `${environment.api}/sse/api/v1/events/${subscriberId}`;
    return new Observable((observer) => {
      const eventSource = this.sseService.getEventSource(url);
      console.log('eventsource', eventSource);
      eventSource.onerror = (event) => {
        this.zone.run(() => {
          eventSource.close();
          observer.error(event);
        });
      };

      /* eventSource.addEventListener('EMPLOYEEID_EVENT_TYPE_OK', (event) => {
        this.zone.run(() => {
          eventSource.close();
          const stringRes: string | null = event.data;
          let res = undefined;
          if (stringRes) {
            res = JSON.parse(stringRes);
          }
          observer.next(res);
        });
      }); */

      /* eventSource.addEventListener('EMPLOYEEID_EVENT_TYPE_KO', (event) => {
        this.zone.run(() => {
          eventSource.close();
          const stringRes: string | null = event.data;
          let res = undefined;
          if (stringRes) {
            res = JSON.parse(stringRes);
          }
          observer.error(res);
        });
      }); */

      eventSource.addEventListener('LIVEID_EVENT_TYPE_OK', (event) => {
        this.zone.run(() => {
          eventSource.close();
          const stringRes: string | null = event.data;
          let res = undefined;
          if (stringRes) {
            res = JSON.parse(stringRes);
          }
          observer.next(res);
        });
      });

      eventSource.addEventListener('LIVEID_EVENT_TYPE_KO', (event) => {
        this.zone.run(() => {
          eventSource.close();
          const stringRes: string | null = event.data;
          let res = undefined;
          if (stringRes) {
            res = JSON.parse(stringRes);
          }
          observer.error(res);
        });
      });

      eventSource.addEventListener('LIVEID_EVENT_TYPE_WARNING', (event) => {
        this.zone.run(() => {
          eventSource.close();
          const stringRes: string | null = event.data;
          let res = undefined;
          if (stringRes) {
            res = JSON.parse(stringRes);
          }
          observer.error(res);
        });
      });

      eventSource.addEventListener('AMLID_EVENT_TYPE_OK', (event) => {
        this.zone.run(() => {
          eventSource.close();
          const stringRes: string | null = event.data;
          let res = undefined;
          if (stringRes) {
            res = JSON.parse(stringRes);
          }
          observer.next(res);
        });
      });

      eventSource.addEventListener('AMLID_EVENT_TYPE_KO', (event) => {
        this.zone.run(() => {
          eventSource.close();
          const stringRes: string | null = event.data;
          let res = undefined;
          if (stringRes) {
            res = JSON.parse(stringRes);
          }
          observer.next(res);
        });
      });

      eventSource.addEventListener('AMLID_EVENT_TYPE_WARNING', (event) => {
        this.zone.run(() => {
          const stringRes: string | null = event.data;
          let res = undefined;
          if (stringRes) {
            res = JSON.parse(stringRes);
          }
          observer.next(res);
        });
      });

      /* eventSource.addEventListener('EMPLOYEEID_EVENT_TYPE_WARNING', (event) => {
        this.zone.run(() => {
          eventSource.close();
          const stringRes: string | null = event.data;
          let res = undefined;
          if (stringRes) {
            res = JSON.parse(stringRes);
          }
          observer.error(res);
        });
      }); */
    });
  }

  getServerEvent<SuccessResponse = object, ErrorResponse = any>(
    subscriberId: string,
    successEventName: string,
    errorEventName: string,
    warningEventName?: string
  ): Observable<SuccessResponse | undefined> {
    const url = `${environment.api}/sse/api/v1/events/${subscriberId}`;
    return new Observable((observer) => {
      const eventSource = this.sseService.getEventSource(url);

      eventSource.onerror = (event) => {
        this.zone.run(() => {
          eventSource.close();
          observer.error(event);
        });
      };

      eventSource.addEventListener(successEventName, (event) => {
        this.zone.run(() => {
          eventSource.close();
          const stringRes: string | null = event.data;
          let res: SuccessResponse | undefined = undefined;
          if (stringRes) {
            res = JSON.parse(stringRes);
          }
          observer.next(res);
          observer.complete();
        });
      });

      eventSource.addEventListener(errorEventName, (event) => {
        this.zone.run(() => {
          eventSource.close();
          const stringRes: string | null = event.data;
          let res: ErrorResponse | undefined = undefined;
          if (stringRes) {
            res = JSON.parse(stringRes);
          }
          observer.error(res);
        });
      });

      if (warningEventName) {
        eventSource.addEventListener(warningEventName, (event) => {
          this.zone.run(() => {
            eventSource.close();
            const stringRes: string | null = event.data;
            let res: ErrorResponse | undefined = undefined;
            if (stringRes) {
              res = JSON.parse(stringRes);
            }
            observer.error(res);
          });
        });
      }
    });
  }
}
